import {SEAT_STATUSES, SEAT_LABELS} from './../seat-statuses';

export default function TripFlightPassengerSeatInfoService(
    tripTravellerAllocationPassengerService,
    travellerUtils
) {
    'ngInject';

    Object.assign(this, {
        associateSeatsWithTravellers,
        isSeatStatusUnconfirmed,
    });

    function associateSeatsWithTravellers(travellers, passengerInfo) {
        if (!passengerInfo.length) {
            return [];
        }
        const {Adult, Child} = travellerUtils.assignInfantNamesToAdults(travellers);
        const adultsAndChildren = [...Adult, ...Child];
        const passengerInfoByTraveller = getPassengerInfoByTraveller(passengerInfo);
        return adultsAndChildren.map((traveller) => {
            const passengerInfoById = passengerInfoByTraveller[traveller.Id];
            const seatStatus = passengerInfoById && SEAT_LABELS[passengerInfoById.SeatStatus] || null;
            const fullName = tripTravellerAllocationPassengerService.getTravellerFullName(traveller);
            const {infantFullName} = traveller;
            return Object.assign({}, {
                fullName,
                seatStatus,
                infantFullName,
                traveller,
            }, passengerInfoById);
        });
    }

    function getPassengerInfoByTraveller(passengerInfo) {
        const passengerInfoByTraveller = {};
        passengerInfo.forEach((info) => {
            passengerInfoByTraveller[info.TripPassengerId] = info;
        });
        return passengerInfoByTraveller;
    }

    function isSeatStatusUnconfirmed(passengerInfo) {
        return passengerInfo.SeatStatus === SEAT_STATUSES.UNCONFIRMED;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-flight-passenger-seat-info/trip-flight-passenger-seat-info-service.js